// React entry point
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

// Import i18n configuration
import './i18n/i18n';

// Inter font — loaded from local node_modules, no CDN needed
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

// Tabler Core SCSS + theme overrides (variables set before tabler import)
import './styles/theme.scss';

// Tabler icon webfont (ti ti-* CSS classes)
import '@tabler/icons-webfont/dist/tabler-icons.min.css';

// Global badge contrast fixes + app layout shell
import './shared/badges.css';
import './shared/app-shell.css';

// Import Chart.js
import 'chart.js';

// Mount React app
const container = document.getElementById('root');

// Only mount if the container exists
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// This allows us to access our React components from Django templates if needed
window.ReactComponents = {
  // Add more components here as needed
  App,
};
